export default from './Message';



// WEBPACK FOOTER //
// ./src/elements/message/index.jsx